export interface RouteMappingEntry {
  /** The clean URL requested by marketing and visible in the browser address bar (e.g. '/about-lips') */
  marketingUrl: string;

  /** The actual Next.js physical route/folder in the codebase (e.g. '/about-us') */
  implementedPath: string;

  /** Set to true if dynamic subpaths (e.g. /our-specialists/:slug -> /specialists/:slug) should also be mapped */
  matchSubpaths?: boolean;
}

export const ROUTE_MAPPING: RouteMappingEntry[] = [
  // ── Mapped Marketing Redirection & Custom Routes ───────────────────────────
  { marketingUrl: '/about-lips', implementedPath: '/about-us' },
  { marketingUrl: '/about-lips/faqs', implementedPath: '/faqs' },
  {
    marketingUrl: '/health-packages',
    implementedPath: '/private-health-packages',
  },
  {
    marketingUrl: '/our-specialists',
    implementedPath: '/our-specialists',
    matchSubpaths: true,
  },
  {
    marketingUrl: '/about-lips/meet-our-nurses-and-care-team',
    implementedPath: '/nurses',
  },
  {
    marketingUrl: '/about-lips/post-surgery-recovery',
    implementedPath: '/loveday',
  },
  {
    marketingUrl: '/for-patients/pricing-and-payments',
    implementedPath: '/pricing-and-payment',
  },
  {
    marketingUrl: '/our-policies/cookies-policy',
    implementedPath: '/cookies',
  },

  // ── Speciality Routes Mapped to Organized prefixes ────────────────────────
  {
    marketingUrl: '/specialities/aesthetics-clinic',
    implementedPath: '/aesthetics-clinic',
  },
  {
    marketingUrl: '/specialities/audiology-hearing-test-battersea-london',
    implementedPath: '/audiology-hearing-test-battersea-london',
  },
  {
    marketingUrl: '/specialities/bone-scan',
    implementedPath: '/bone-scan',
  },
  {
    marketingUrl: '/specialities/general-surgery',
    implementedPath: '/general-surgery',
  },
  {
    marketingUrl: '/specialities/geriatrics',
    implementedPath: '/geriatrics',
  },
  {
    marketingUrl: '/specialities/gynaecology-and-obstetrics',
    implementedPath: '/gynaecology-and-obstetrics',
  },
  {
    marketingUrl: '/specialities/haematology',
    implementedPath: '/haematology',
  },
  {
    marketingUrl: '/specialities/liver-health-fibroscan',
    implementedPath: '/liver-health-liver-scans',
  },
  {
    marketingUrl: '/specialities/maxillofacial',
    implementedPath: '/maxillofacial',
  },
  {
    marketingUrl: '/specialities/menopause',
    implementedPath: '/menopause-clinic',
  },
  {
    marketingUrl: '/specialities/neurology',
    implementedPath: '/neurology',
  },
  {
    marketingUrl: '/specialities/spine-and-neurosurgery',
    implementedPath: '/neurosurgery',
  },
  {
    marketingUrl: '/specialities/ophthalmology',
    implementedPath: '/ophthalmology',
  },
  {
    marketingUrl: '/specialities/childrens-health-paediatrics',
    implementedPath: '/private-paediatrician',
  },
  {
    marketingUrl: '/specialities/psychiatry',
    implementedPath: '/psychiatry',
  },
  {
    marketingUrl: '/specialities/rheumatology',
    implementedPath: '/rheumatology',
  },
  {
    marketingUrl: '/specialities/sexual-health',
    implementedPath: '/sexual-health',
  },
  {
    marketingUrl: '/specialities/ultrasound',
    implementedPath: '/ultrasound',
  },
  {
    marketingUrl: '/specialities/urology-and-andrology',
    implementedPath: '/urology-and-andrology',
  },
  {
    marketingUrl: '/specialities/urgent-care-centre',
    implementedPath: '/emergency-clinic-london',
  },
  {
    marketingUrl: '/specialities/breast-clinic',
    implementedPath: '/breast-clinic',
  },
  {
    // Search option slug (SPEC_OPTIONS 'private-breast-clinic') must resolve
    // to the real /breast-clinic page rather than a 404.
    marketingUrl: '/specialities/private-breast-clinic',
    implementedPath: '/breast-clinic',
  },
  {
    marketingUrl: '/specialities/dental',
    implementedPath: '/dental-services',
  },
  {
    marketingUrl: '/specialities/ent',
    implementedPath: '/ent',
  },
  {
    marketingUrl: '/specialities/exroid',
    implementedPath: '/exroid',
  },
  {
    marketingUrl: '/specialities/gastric-alimetry',
    implementedPath: '/gastric-alimetry',
  },
  {
    marketingUrl: '/specialities/gastroenterology',
    implementedPath: '/gastroenterology',
  },
  {
    marketingUrl: '/specialities/baby-hip-clinic',
    implementedPath: '/baby-hip-clinic',
  },
  {
    marketingUrl: '/specialities/private-gp',
    implementedPath: '/private-gp',
  },
  {
    marketingUrl: '/specialities/gp-membership',
    implementedPath: '/gp-membership',
  },
  {
    marketingUrl: '/specialities/hip-and-knee-replacement',
    implementedPath: '/hip-and-knee',
  },
  {
    // Search option slug (SPEC_OPTIONS 'hip-replacement-and-knee-replacement')
    // must resolve to the real /hip-and-knee page rather than a 404.
    marketingUrl: '/specialities/hip-replacement-and-knee-replacement',
    implementedPath: '/hip-and-knee',
  },
  {
    marketingUrl: '/specialities/knee-osteoarthritis',
    implementedPath: '/arthrosamid',
  },
  {
    marketingUrl: '/specialities/arthrosamid',
    implementedPath: '/arthrosamid',
  },
  {
    marketingUrl: '/specialities/mole-mapping',
    implementedPath: '/mole-mapping',
  },
  {
    marketingUrl: '/specialities/physiotherapy',
    implementedPath: '/physiotherapy',
  },
  {
    marketingUrl: '/specialities/plastic-surgery',
    implementedPath: '/plastic-surgery',
  },
  {
    marketingUrl: '/specialities/obstructive-sleep-apnoea',
    implementedPath: '/sleep-apnoea',
  },
  {
    marketingUrl: '/specialities/imaging',
    implementedPath: '/radiology',
  },
  {
    marketingUrl: '/specialities/cardiology',
    implementedPath: '/specialities/cardiology',
  },
  {
    marketingUrl: '/specialities/dermatology',
    implementedPath: '/dermatology',
  },
  {
    marketingUrl: '/specialities/dietetics',
    implementedPath: '/dietetics',
  },
  {
    marketingUrl: '/specialities/female-fertility',
    implementedPath: '/fertility',
  },
  {
    marketingUrl: '/specialities/blood-tests',
    implementedPath: '/blood-test',
  },
  {
    marketingUrl: '/specialities/skin-lumps-and-bumps',
    implementedPath: '/lumps-and-bumps',
  },
  {
    marketingUrl: '/specialities/trauma-and-orthopaedics-lower-limb',
    implementedPath: '/trauma-and-orthopaedics-lower-limb',
  },
  {
    marketingUrl: '/specialities/trauma-and-orthopaedics-upper-limb',
    implementedPath: '/trauma-and-orthopaedics-upper-limb',
  },
  {
    marketingUrl: '/specialities/trauma-and-orthopaedics',
    implementedPath: '/trauma-and-orthopaedics',
  },
  {
    marketingUrl: '/specialities/trt',
    implementedPath: '/trt',
  },
  {
    marketingUrl: '/specialities/gut-health-test',
    implementedPath: '/gut-health-test',
  },
  // {
  //   marketingUrl: '/specialities/metabolic-health-clinic-london',
  //   implementedPath: '/metabolic-health-clinic-london',
  // },
  {
    marketingUrl: '/specialities/hearing-aids-london',
    implementedPath: '/hearing-aids-london',
  },
  {
    marketingUrl: '/specialities/iron-infusion-london',
    implementedPath: '/iron-infusion-london',
  },
  {
    marketingUrl: '/specialities/tmj-specialist-london',
    implementedPath: '/tmj-specialist-london',
  },
  {
    marketingUrl: '/specialities/emg-nerve-conduction-test',
    implementedPath: '/emg-nerve-conduction-test',
  },
  {
    marketingUrl: '/specialities/nutritionist-london',
    implementedPath: '/nutritionist-london',
  },

  // ── Identical/Standard Routes (Listed for central path documentation) ───────
  { marketingUrl: '/', implementedPath: '/' },
  {
    marketingUrl: '/our-policies/cancellation-policy',
    implementedPath: '/cancellation-policy',
  },
  {
    marketingUrl: '/our-policies/gp-membership-terms-conditions',
    implementedPath: '/gp-membership-terms-conditions',
  },
  {
    marketingUrl: '/our-policies/complaint-policy',
    implementedPath: '/complaint-policy',
  },
  { marketingUrl: '/complaints-policy', implementedPath: '/complaint-policy' },
  {
    marketingUrl: '/about-lips/contact-us',
    implementedPath: '/contact-us',
  },
  {
    marketingUrl: '/for-patients/new-patient-information',
    implementedPath: '/new-patient-information',
  },
  { marketingUrl: '/pharmacy', implementedPath: '/pharmacy' },
  {
    marketingUrl: '/our-policies/privacy-policy',
    implementedPath: '/privacy-policy',
  },
  { marketingUrl: '/specialities', implementedPath: '/specialities' },
  {
    marketingUrl: '/our-policies/terms-and-conditions',
    implementedPath: '/terms-and-conditions',
  },
  {
    marketingUrl: '/our-policies/terms-and-conditions/introduction-services',
    implementedPath: '/terms-and-conditions/introduction-services',
  },
  {
    marketingUrl:
      '/our-policies/terms-and-conditions/medical-and-surgical-procedures',
    implementedPath: '/terms-and-conditions/medical-and-surgical-procedures',
  },
  {
    marketingUrl:
      '/our-policies/terms-and-conditions/returns-refunds-and-cancellations',
    implementedPath: '/terms-and-conditions/returns-refunds-and-cancellations',
  },
  {
    marketingUrl: '/about-lips/clinicians-and-referrals',
    implementedPath: '/careers',
  },
  {
    marketingUrl: '/for-patients/patient-referrals',
    implementedPath: '/for-clinicians',
  },
  // { marketingUrl: '/feedback', implementedPath: '/feedback' },
  {
    marketingUrl: '/for-patients/leave-feedback',
    implementedPath: '/feedback',
  },
  {
    marketingUrl: '/about-lips/investor-relations',
    implementedPath: '/investor-relations',
  },
  {
    marketingUrl: '/submit-complaint',
    implementedPath: '/submit-complaint',
  },
  {
    marketingUrl: '/about-lips/getting-here',
    implementedPath: '/getting-here',
  },
  {
    marketingUrl: '/about-lips/health-blogs',
    implementedPath: '/blogs',
    matchSubpaths: true,
  },
  {
    marketingUrl: '/about-lips/news-and-events',
    implementedPath: '/news-and-events',
    matchSubpaths: true,
  },
  {
    marketingUrl: '/sharkninja-event',
    implementedPath: '/sharkninja',
  },
  // {
  //   marketingUrl: '/about-lips/events/technogym-event',
  //   implementedPath: '/technogym',
  // },
  {
    marketingUrl: '/for-patients/prepare-for-your-appointment',
    implementedPath: '/prepare-for-your-visit',
  },

  // ── Landing Pages (SEO) ──────────────────────────────────────────────────
  { marketingUrl: '/paediatric-clinic', implementedPath: '/paediatric-clinic' },
  {
    marketingUrl: '/private-ultrasound-scans',
    implementedPath: '/private-ultrasound-scans',
  },
  {
    marketingUrl: '/private-ultrasound-scans-Battersea',
    implementedPath: '/private-ultrasound-scans-battersea',
  },
  { marketingUrl: '/female-ultrasound', implementedPath: '/female-ultrasound' },
  { marketingUrl: '/gp-access', implementedPath: '/gp-access' },
  { marketingUrl: '/urgent-care', implementedPath: '/urgent-care' },
  { marketingUrl: '/blood-tests', implementedPath: '/blood-tests' },
  { marketingUrl: '/bone-scan-clinic', implementedPath: '/bone-scan-clinic' },
  {
    marketingUrl: '/sleep-apnoea-clinic',
    implementedPath: '/sleep-apnoea-clinic',
  },
  {
    marketingUrl: '/specialities/longevity-centre',
    implementedPath: '/longevity-centre',
  },
];

/**
 * Alias URLs that should 301 to a canonical marketing URL.
 * Handled in proxy so they work even when next.config redirects are
 * disabled (NEXT_DEV_FAST=true). Keep matching entries in redirectLinks
 * for production next.config coverage.
 */
export const MARKETING_ALIASES: Array<{
  source: string;
  destination: string;
}> = [
  {
    source: '/general-practice',
    destination: '/specialities/private-gp',
  },
  {
    source: '/specialities/general-practice',
    destination: '/specialities/private-gp',
  },
  {
    source: '/general-practitioner',
    destination: '/specialities/private-gp',
  },
  {
    source: '/specialities/radiology',
    destination: '/specialities/imaging',
  },
];

/**
 * Resolves a given URL to its clean marketing/sitemap canonical URL from ROUTE_MAPPING.
 * If no mapping exists, it returns the URL unchanged.
 */
export function resolveMarketingUrl(
  url: string | undefined,
): string | undefined {
  if (!url) return url;

  // Preserve external, fragment, and mailto/tel links
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('#') ||
    url.startsWith('mailto:') ||
    url.startsWith('tel:')
  ) {
    return url;
  }

  // Split query parameters if any
  const [pathWithSlash, query] = url.split('?');

  // Normalize path: strip trailing slash except for root '/'
  const normalizedPath =
    pathWithSlash.endsWith('/') && pathWithSlash.length > 1
      ? pathWithSlash.slice(0, -1)
      : pathWithSlash;

  // 1. Exact match in ROUTE_MAPPING for either implementedPath or marketingUrl
  const exactMatch = ROUTE_MAPPING.find(
    (entry) =>
      entry.implementedPath === normalizedPath ||
      entry.marketingUrl === normalizedPath,
  );
  if (exactMatch) {
    const matchedUrl = exactMatch.marketingUrl;
    return query ? `${matchedUrl}?${query}` : matchedUrl;
  }

  // 2. Subpath matches (matchSubpaths: true)
  const subpathMatch = ROUTE_MAPPING.filter((entry) => entry.matchSubpaths)
    .sort((a, b) => b.implementedPath.length - a.implementedPath.length)
    .find((entry) => normalizedPath.startsWith(entry.implementedPath + '/'));
  if (subpathMatch) {
    const subpath = normalizedPath.slice(subpathMatch.implementedPath.length);
    const matchedUrl = `${subpathMatch.marketingUrl}${subpath}`;
    return query ? `${matchedUrl}?${query}` : matchedUrl;
  }

  // 3. Fallback for /specialities/ prefix mapping where the slug matches an implemented path (e.g. /specialities/menopause-clinic -> /specialities/menopause)
  if (normalizedPath.startsWith('/specialities/')) {
    const slug = normalizedPath.substring('/specialities/'.length);
    const matchingImpl = ROUTE_MAPPING.find(
      (entry) => entry.implementedPath === `/${slug}`,
    );
    if (matchingImpl) {
      const matchedUrl = matchingImpl.marketingUrl;
      return query ? `${matchedUrl}?${query}` : matchedUrl;
    }
  }

  // If no mapping found, return original URL (with trailing slash intact)
  return url;
}

export const SPECIALITY_ROUTES = {
  emergencyClinic:
    resolveMarketingUrl('/emergency-clinic-london') ||
    '/emergency-clinic-london',
  aesthetics: resolveMarketingUrl('/aesthetics-clinic') || '/aesthetics-clinic',
  audiology:
    resolveMarketingUrl('/audiology-hearing-test-battersea-london') ||
    '/audiology-hearing-test-battersea-london',
  bloodTests: resolveMarketingUrl('/blood-test') || '/blood-test',
  boneScan: resolveMarketingUrl('/bone-scan') || '/bone-scan',
  breastClinic: resolveMarketingUrl('/breast-clinic') || '/breast-clinic',
  cardiology:
    resolveMarketingUrl('/specialities/cardiology') ||
    '/specialities/cardiology',
  ChildrensHealth:
    resolveMarketingUrl('/specialities/childrens-health-paediatrics') ||
    '/specialities/childrens-health-paediatrics',
  sleepApnoea: resolveMarketingUrl('/sleep-apnoea') || '/sleep-apnoea',
  dental: resolveMarketingUrl('/dental-services') || '/dental-services',
  dermatology: resolveMarketingUrl('/dermatology') || '/dermatology',
  dietetics: resolveMarketingUrl('/dietetics') || '/dietetics',
  ent: resolveMarketingUrl('/ent') || '/ent',
  exroid: resolveMarketingUrl('/exroid') || '/exroid',
  fertility: resolveMarketingUrl('/fertility') || '/fertility',
  gastricAlimetry:
    resolveMarketingUrl('/gastric-alimetry') || '/gastric-alimetry',
  gastroenterology:
    resolveMarketingUrl('/gastroenterology') || '/gastroenterology',
  generalSurgery: resolveMarketingUrl('/general-surgery') || '/general-surgery',
  geriatrics: resolveMarketingUrl('/geriatrics') || '/geriatrics',
  gp: resolveMarketingUrl('/private-gp') || '/private-gp',
  gpMembership: resolveMarketingUrl('/gp-membership') || '/gp-membership',
  gynaecologyAndObstetrics:
    resolveMarketingUrl('/gynaecology-and-obstetrics') ||
    '/gynaecology-and-obstetrics',
  haematology: resolveMarketingUrl('/haematology') || '/haematology',
  hipAndKnee: resolveMarketingUrl('/hip-and-knee') || '/hip-and-knee',
  arthrosamid: resolveMarketingUrl('/arthrosamid') || '/arthrosamid',
  liverHealth:
    resolveMarketingUrl('/liver-health-liver-scans') ||
    '/liver-health-liver-scans',
  maxillofacial: resolveMarketingUrl('/maxillofacial') || '/maxillofacial',
  menopause: resolveMarketingUrl('/menopause-clinic') || '/menopause-clinic',
  moleMapping: resolveMarketingUrl('/mole-mapping') || '/mole-mapping',
  neurology: resolveMarketingUrl('/neurology') || '/neurology',
  ophthalmology: resolveMarketingUrl('/ophthalmology') || '/ophthalmology',
  physiotherapy: resolveMarketingUrl('/physiotherapy') || '/physiotherapy',
  plasticSurgery: resolveMarketingUrl('/plastic-surgery') || '/plastic-surgery',
  psychiatry: resolveMarketingUrl('/psychiatry') || '/psychiatry',
  radiology: resolveMarketingUrl('/radiology') || '/radiology',
  rheumatology: resolveMarketingUrl('/rheumatology') || '/rheumatology',
  sexualHealth: resolveMarketingUrl('/sexual-health') || '/sexual-health',
  lumpsAndBumps: resolveMarketingUrl('/lumps-and-bumps') || '/lumps-and-bumps',
  neurosurgery: resolveMarketingUrl('/neurosurgery') || '/neurosurgery',
  traumaAndOrthopaedics:
    resolveMarketingUrl('/trauma-and-orthopaedics') ||
    '/trauma-and-orthopaedics',
  traumaLowerLimb:
    resolveMarketingUrl('/trauma-and-orthopaedics-lower-limb') ||
    '/trauma-and-orthopaedics-lower-limb',
  traumaUpperLimb:
    resolveMarketingUrl('/trauma-and-orthopaedics-upper-limb') ||
    '/trauma-and-orthopaedics-upper-limb',
  trt: resolveMarketingUrl('/trt') || '/trt',
  ultrasound: resolveMarketingUrl('/ultrasound') || '/ultrasound',
  urologyAndAndrology:
    resolveMarketingUrl('/urology-and-andrology') || '/urology-and-andrology',
  gutHealthTest: resolveMarketingUrl('/gut-health-test') || '/gut-health-test',
  babyHipClinic: resolveMarketingUrl('/baby-hip-clinic') || '/baby-hip-clinic',
  hearingAid:
    resolveMarketingUrl('/hearing-aids-london') || '/hearing-aids-london',
  ironInfusion:
    resolveMarketingUrl('/iron-infusion-london') || '/iron-infusion-london',
  tmj:
    resolveMarketingUrl('/tmj-specialist-london') || '/tmj-specialist-london',
  emg:
    resolveMarketingUrl('/emg-nerve-conduction-test') ||
    '/emg-nerve-conduction-test',
  nutritionist:
    resolveMarketingUrl('/nutritionist-london') || '/nutritionist-london',
  longevityCentre:
    resolveMarketingUrl('/longevity-centre') || '/longevity-centre',
} as const;

export const PAGE_ROUTES = {
  home: resolveMarketingUrl('/') || '/',
  aboutUs: resolveMarketingUrl('/about-us') || '/about-us',
  contactUs: resolveMarketingUrl('/contact-us') || '/contact-us',
  newPatientInformation:
    resolveMarketingUrl('/new-patient-information') ||
    '/new-patient-information',
  preparingForYourAppointment:
    resolveMarketingUrl('/prepare-for-your-visit') || '/prepare-for-your-visit',
  pricingAndPayments:
    resolveMarketingUrl('/pricing-and-payment') || '/pricing-and-payment',
  cookiesPolicy: resolveMarketingUrl('/cookies') || '/cookies',
  cancellationPolicy:
    resolveMarketingUrl('/cancellation-policy') || '/cancellation-policy',
  complaintPolicy:
    resolveMarketingUrl('/complaint-policy') || '/complaint-policy',
  privacyPolicy: resolveMarketingUrl('/privacy-policy') || '/privacy-policy',
  termsAndConditions:
    resolveMarketingUrl('/terms-and-conditions') || '/terms-and-conditions',
  testing: resolveMarketingUrl('/testing') || '/testing',
  specialists: '/our-specialists',
  nurses:
    resolveMarketingUrl('/meet-our-nurses-and-care-team') ||
    '/meet-our-nurses-and-care-team',
  specialities: resolveMarketingUrl('/specialities') || '/specialities',
  privateHealthPackages:
    resolveMarketingUrl('/private-health-packages') ||
    '/private-health-packages',
  careers: resolveMarketingUrl('/careers') || '/careers',
  forClinicians: resolveMarketingUrl('/for-clinicians') || '/for-clinicians',
  // feedback: resolveMarketingUrl('/feedback') || '/feedback',
  leaveFeedback: resolveMarketingUrl('/feedback') || '/feedback',
  investorRelations:
    resolveMarketingUrl('/investor-relations') || '/investor-relations',
  submitComplaint:
    resolveMarketingUrl('/submit-complaint') || '/submit-complaint',
  pharmacyBook: resolveMarketingUrl('/pharmacy/book') || '/pharmacy/book',
  gettingHere:
    resolveMarketingUrl('/getting-here') || '/about-lips/getting-here',
  blogs: resolveMarketingUrl('/blogs') || '/blogs',
  postSurgery:
    resolveMarketingUrl('/about-lips/post-surgery-recovery') || '/loveday',
  pharmacy: resolveMarketingUrl('/pharmacy') || '/pharmacy',
  conditions: resolveMarketingUrl('/conditions') || '/conditions',
  bloodTests: resolveMarketingUrl('/blood-test') || '/blood-test',
} as const;

export function resolveSpecialityUrlBySlug(slug: string): string {
  const cleanSlug = slug
    .replace(/-clinic$/, '')
    .replace(/s$/, '')
    .replace(/-services$/, '');

  const match = ROUTE_MAPPING.find((entry) => {
    const mUrl = entry.marketingUrl;
    if (!mUrl.startsWith('/specialities/')) return false;

    const routeSlug = mUrl
      .substring('/specialities/'.length)
      .replace(/-clinic$/, '')
      .replace(/s$/, '')
      .replace(/-services$/, '');
    const implSlug = entry.implementedPath
      .substring(1)
      .replace(/-clinic$/, '')
      .replace(/s$/, '')
      .replace(/-services$/, '');

    return (
      routeSlug === cleanSlug ||
      routeSlug.startsWith(`${cleanSlug}-`) ||
      routeSlug.endsWith(`-${cleanSlug}`) ||
      cleanSlug.startsWith(`${routeSlug}-`) ||
      cleanSlug.endsWith(`-${routeSlug}`) ||
      implSlug === cleanSlug ||
      implSlug.startsWith(`${cleanSlug}-`) ||
      implSlug.endsWith(`-${cleanSlug}`) ||
      cleanSlug.startsWith(`${implSlug}-`) ||
      cleanSlug.endsWith(`-${implSlug}`)
    );
  });

  if (match) {
    return match.marketingUrl;
  }

  const defaultPath = `/specialities/${slug}`;
  return resolveMarketingUrl(defaultPath) || defaultPath;
}
